import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';

import { ENTITY_TYPES, SelectOption } from '@shared/types';
import { Observable } from '@shared/rx';
import { FormControl } from '@angular/forms';
import { DropdownBaseComponent } from '@geniuspos/ui-shared/modules/xdm-shared-components/base-component/dropdown/dropdown-base.component';
import { I18n } from '@app/i18n/strings-keys';

interface IEntitySelectMenuCallBackFunctions {
  onScroll: Function;
  setValue: Function;
  trackByValue: Function;
  addNewItem: Function;
}

interface IEntitySelectMenuFlags {
  busy$: Observable<boolean>;
  dataSourceEmptyValue: boolean;
  canAdd: boolean;
  canAddWidgetData: boolean;
  hasAddPermission: boolean;
  insertable: boolean;
  insertableVisibility$: Observable<boolean>;
  hideShowNoMatches?: boolean;
}

@Component({
  selector: 'xux-input-entity-select-menu',
  templateUrl: 'xux-input-entity-select-menu.component.html',
  styleUrls: ['./xux-input-entity-select-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XuxInputEntitySelectMenuComponent extends DropdownBaseComponent {
  @Input() public callBackFunctions: IEntitySelectMenuCallBackFunctions;
  @Input() public optionFlags: IEntitySelectMenuFlags;
  @Input() public selectOptions$: Observable<SelectOption[]>;
  @Input() public entityName: ENTITY_TYPES;
  @Input() public searchControl: FormControl;

  public staticTextContent = {
    NoMatches: I18n.Common.NoMatches,
    NewEntity: I18n.Common.NewEntity,
    AddNew: I18n.Common.AddNewBrackets,
  };
}
